"use strict";

var BindMixin = {
  componentWillMount: function componentWillMount() {
    var _this = this;

    if (this.methodsToBind) {
      this.methodsToBind.forEach(function (method) {
        _this[method] = _this[method].bind(_this);
      });
    }
  }
};

module.exports = BindMixin;


//////////////////
// WEBPACK FOOTER
// ./~/reactjs-components/lib/Mixin/BindMixin.js
// module id = 1292
// module chunks = 2